import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

export const AnnouncementBanner = () => {
  const [dismissed, setDismissed] = useState([]);
  const { data } = useQuery({
    queryKey: ["announcements"],
    queryFn: async () => (await api.get("/announcements")).data,
    refetchInterval: 60000,
  });

  const latest = (data || []).find((a) => !dismissed.includes(a.id));
  if (!latest) return null;

  const toneBg = latest.tone === "sale" ? "from-[#3a2a0f] to-[#1a1206]" : latest.tone === "new" ? "from-[#0f2a22] to-[#07120e]" : "from-[#1a1a12] to-[#0d0d08]";

  return (
    <div className={`relative z-[55] bg-gradient-to-r ${toneBg} border-b border-amber-400/20`} data-testid="announcement-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 text-sm">
        <Megaphone size={15} className="text-champagne shrink-0" />
        <p className="flex-1 text-slate-200 truncate"><span className="text-champagne font-medium">{latest.title}</span> — {latest.body}</p>
        <button onClick={() => setDismissed([...dismissed, latest.id])} data-testid="dismiss-announcement" className="text-slate-400 hover:text-white transition-colors"><X size={15} /></button>
      </div>
    </div>
  );
};
